var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":_vm.isPC ? 'floatten-pc' : 'floatten-mobile'}},[_c('div',{class:_vm.containerClass},[_c('BubbleIcon',{directives:[{name:"track-click",rawName:"v-track-click",value:(_vm.BTN_EVTS.CHATBUBBLE_OPEN),expression:"BTN_EVTS.CHATBUBBLE_OPEN"}],staticClass:"msg-bubble-icon",on:{"click":_vm.openHelp}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }